import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "kzt-page" }
const _hoisted_2 = { class: "kzt-shell" }
const _hoisted_3 = { class: "kzt-card kzt-stack" }
const _hoisted_4 = { class: "kzt-route" }
const _hoisted_5 = { class: "kzt-route__line" }
const _hoisted_6 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "kzt-amount" }
const _hoisted_12 = { class: "kzt-warning" }
const _hoisted_13 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_14 = ["d"]
const _hoisted_15 = { class: "kzt-card kzt-stack" }
const _hoisted_16 = { class: "kzt-row__icon" }
const _hoisted_17 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_18 = ["d"]
const _hoisted_19 = { class: "kzt-row__body" }
const _hoisted_20 = { class: "kzt-label" }
const _hoisted_21 = { class: "kzt-value" }
const _hoisted_22 = ["aria-label", "onClick"]
const _hoisted_23 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_24 = ["d"]
const _hoisted_25 = { class: "kzt-row" }
const _hoisted_26 = { class: "kzt-row__icon" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_29 = ["d"]
const _hoisted_30 = { class: "kzt-row__body" }
const _hoisted_31 = { class: "kzt-label" }
const _hoisted_32 = { class: "kzt-value" }
const _hoisted_33 = {
  key: 0,
  class: "kzt-country"
}
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_36 = ["d"]
const _hoisted_37 = { class: "kzt-card kzt-stack" }
const _hoisted_38 = { class: "kzt-timer" }
const _hoisted_39 = { class: "kzt-progress" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_42 = ["d"]
const _hoisted_43 = {
  key: 1,
  class: "kzt-card kzt-state"
}
const _hoisted_44 = { class: "kzt-state__icon kzt-state__icon--success" }
const _hoisted_45 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_46 = ["d"]
const _hoisted_47 = { class: "kzt-state__icon kzt-state__icon--yellow" }
const _hoisted_48 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_49 = ["d"]
const _hoisted_50 = { class: "kzt-state__icon kzt-state__icon--danger" }
const _hoisted_51 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_52 = ["d"]
const _hoisted_53 = { class: "kzt-row" }
const _hoisted_54 = { class: "kzt-row__icon" }
const _hoisted_55 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_56 = ["d"]
const _hoisted_57 = { class: "kzt-row__body" }
const _hoisted_58 = { class: "kzt-label" }
const _hoisted_59 = { class: "kzt-value" }
const _hoisted_60 = ["aria-label"]
const _hoisted_61 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_62 = ["d"]
const _hoisted_63 = ["href"]
const _hoisted_64 = ["aria-label"]
const _hoisted_65 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_66 = ["d"]
const _hoisted_67 = { class: "kzt-modal__title" }
const _hoisted_68 = {
  key: 0,
  class: "kzt-stack"
}
const _hoisted_69 = { class: "kzt-modal__text" }
const _hoisted_70 = { class: "kzt-slide" }
const _hoisted_71 = {
  key: 0,
  class: "kzt-error",
  role: "alert"
}
const _hoisted_72 = ["alt"]
const _hoisted_73 = {
  key: 1,
  class: "kzt-stack"
}
const _hoisted_74 = { class: "kzt-warning" }
const _hoisted_75 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_76 = ["d"]
const _hoisted_77 = { class: "kzt-modal__text" }
const _hoisted_78 = { class: "kzt-row__icon" }
const _hoisted_79 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_80 = ["d"]
const _hoisted_81 = { class: "kzt-row__body" }
const _hoisted_82 = { class: "kzt-label" }
const _hoisted_83 = { class: "kzt-value" }
const _hoisted_84 = ["aria-label", "onClick"]
const _hoisted_85 = {
  class: "kzt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_86 = ["d"]
const _hoisted_87 = {
  key: 0,
  class: "kzt-stack"
}
const _hoisted_88 = {
  class: "kzt-label",
  for: "kzt-trx-input"
}
const _hoisted_89 = ["value", "placeholder"]
const _hoisted_90 = {
  key: 0,
  class: "kzt-error"
}
const _hoisted_91 = ["disabled"]

import "@/assets/css/kazakhstan-cross-border.css"
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";
import {copy, state as copyState} from "@/service/helper";
import {DealStatus} from "@/enum/DealStatus";
import {InvoiceStatus} from "@/enum/InvoiceStatus";

type ModalName = 'instruction' | 'confirm'

const KASPI_LOGO = '/img/methods/kaspi.png'
const INSTRUCTION_GIF = '/img/instructions_kaspi/transfer-ru.gif'


export default /*@__PURE__*/_defineComponent({
  __name: 'KazakhstanCrossBorderPage',
  props: {
    confirmTransfer: { type: Function },
    cancelDeal: { type: Function },
    currentDeal: {},
    invoice: {},
    transactionId: {},
    transactionIdError: {}
  },
  emits: ["update:transactionId"],
  setup(__props: any, { emit: __emit }) {

const icons: Record<string, string> = {
  chevron: 'M9 6l6 6-6 6',
  warning: 'M12 3L2 21h20z M12 9v5 M12 17v1',
  user: 'M5 21v-3a7 7 0 0114 0v3 M12 3a4 4 0 100 8 4 4 0 000-8',
  card: 'M3 6h18v13H3z M3 10h18',
  bank: 'M3 9h18L12 3z M5 11v8 M12 11v8 M19 11v8 M2 22h20',
  copy: 'M9 9h11v11H9z M15 5V2H2v13h3',
  graduation: 'M2 9l10-5 10 5-10 5z M6 11v6c4 3 8 3 12 0v-6 M22 9v7',
  doubleCheck: 'M18 6L7 17l-5-5 M22 10l-7 7-2-2',
  check: 'M5 12l4 4L20 5',
  close: 'M6 6l12 12 M6 18L18 6',
  clock: 'M12 8v5l3 2 M4 4L2 6 M20 4l2 2',
  info: 'M12 8v1 M12 12v5',
}

const props = __props

const emit = __emit

const {t, te} = useI18n({useScope: 'global'})

const now = ref(Date.now())
const modal = ref<ModalName | null>(null)
const logoFailed = ref(false)
const instructionFailed = ref(false)
const confirmPending = ref(false)
let timer: number | null = null

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now()
  }, 250)
})

onUnmounted(() => {
  if (timer !== null) {
    clearInterval(timer)
  }
})

const isFinal = computed(() => [InvoiceStatus.PAID, InvoiceStatus.CANCELED, InvoiceStatus.EXPIRED].includes(props.invoice.status)
  || [DealStatus.COMPLETED, DealStatus.CANCELED].includes(props.currentDeal.status))

const phase = computed<'pay' | 'verify' | 'result'>(() => {
  if (isFinal.value) {
    return 'result'
  }
  return props.currentDeal.status === DealStatus.TRANSFER_WAITING ? 'pay' : 'verify'
})

const isPaid = computed(() => props.invoice.status === InvoiceStatus.PAID || props.currentDeal.status === DealStatus.COMPLETED)
const isExpired = computed(() => props.invoice.status === InvoiceStatus.EXPIRED)
const isDispute = computed(() => props.currentDeal.status === DealStatus.DISPUTE)
const returnUrl = computed(() => isPaid.value ? props.invoice.successUrl : props.invoice.cancelUrl)
const invoiceNumber = computed(() => props.invoice.internalId || props.invoice.id)

const deadline = computed(() => new Date(props.currentDeal.canceledAt).getTime())
const secondsLeft = computed(() => Math.max(0, Math.floor((deadline.value - now.value) / 1000)))
const canAct = computed(() => phase.value === 'pay' && secondsLeft.value > 0)

const timeLeft = computed(() => {
  const hours = Math.floor(secondsLeft.value / 3600)
  const minutes = Math.floor((secondsLeft.value % 3600) / 60)
  const seconds = secondsLeft.value % 60
  const parts = hours > 0 ? [hours, minutes, seconds] : [minutes, seconds]
  return parts.map((part) => String(part).padStart(2, '0')).join(':')
})

const timePercent = computed(() => {
  const createdAt = new Date(props.currentDeal.createdAt).getTime()
  const total = deadline.value - createdAt
  if (total <= 0) {
    return 0
  }
  return Math.min(100, Math.max(0, (deadline.value - now.value) / total * 100))
})

const progressClass = computed(() => {
  if (timePercent.value < 33) {
    return 'is-danger'
  }
  if (timePercent.value <= 66) {
    return 'is-warning'
  }
  return ''
})

const amountText = computed(() => numberFormatter.formatMoney(Number(props.invoice.sum.amount), props.invoice.sum.currency) ?? '')

const receiverBank = computed(() => {
  const method = props.currentDeal.paymentMethod
  if (method && te(`methods.${method}`)) {
    return t(`methods.${method}`)
  }
  return method ?? ''
})

const receiverLogo = computed(() => props.currentDeal.paymentMethod
  ? paymentMethodsHelper.getLogo(props.currentDeal.paymentMethod)
  : '')

watch(() => props.currentDeal.paymentMethod, () => {
  logoFailed.value = false
})

const countryName = computed(() => {
  const currency = props.invoice.crossBorderCurrency
  return currency && te(`countries.${currency}`) ? t(`countries.${currency}`) : ''
})

const showTajikFlag = computed(() => props.invoice.crossBorderCurrency === 'TJS')

const rawRequisites = computed(() => String(props.currentDeal.requisites?.requisites ?? '').trim())

const cardText = computed(() => {
  const compact = rawRequisites.value.replace(/\s/g, '')
  if (/^\d{12,}$/.test(compact)) {
    return compact.replace(/(\d{4})(?=\d)/g, '$1 ')
  }
  return rawRequisites.value
})

const holder = computed(() => String(props.currentDeal.requisites?.holder ?? '').trim())

const rows = computed(() => [
  {key: 'card', icon: 'card', label: t('kazakhstan-cross-border.field-card'), value: cardText.value, copy: rawRequisites.value},
  {key: 'holder', icon: 'user', label: t('kazakhstan-cross-border.field-recipient'), value: holder.value, copy: holder.value},
].filter((row) => row.value !== ''))

const confirmRows = computed(() => [
  {key: 'amount', icon: 'card', label: t('kazakhstan-cross-border.field-amount'), value: amountText.value, copy: ''},
  ...rows.value,
])

const modalTitle = computed(() => t(modal.value === 'instruction'
  ? 'kazakhstan-cross-border.instruction'
  : 'kazakhstan-cross-border.confirm-title'))

const closeModal = () => {
  modal.value = null
}

watch(phase, (value) => {
  if (value !== 'pay') {
    closeModal()
    confirmPending.value = false
  }
})

const onTransactionIdInput = (e: Event) => {
  emit('update:transactionId', (e.target as HTMLInputElement).value)
}

const onConfirm = async () => {
  if (!canAct.value || confirmPending.value) {
    return
  }
  confirmPending.value = true
  try {
    await props.confirmTransfer()
  } finally {
    if (phase.value === 'pay') {
      confirmPending.value = false
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (phase.value === 'pay')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("section", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    class: "kzt-logo",
                    src: KASPI_LOGO,
                    alt: ""
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('kazakhstan-cross-border.sender')), 1)
                ]),
                _createElementVNode("span", _hoisted_5, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                    _createElementVNode("path", {
                      d: icons.chevron
                    }, null, 8, _hoisted_7)
                  ]))
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(receiverBank.value) + " ", 1),
                  (receiverLogo.value && !logoFailed.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "kzt-logo",
                        src: receiverLogo.value,
                        alt: "",
                        onError: _cache[0] || (_cache[0] = ($event: any) => (logoFailed.value = true))
                      }, null, 40, _hoisted_8))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                        _createElementVNode("path", {
                          d: icons.bank
                        }, null, 8, _hoisted_10)
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(amountText.value), 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                  _createElementVNode("path", {
                    d: icons.warning
                  }, null, 8, _hoisted_14)
                ])),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('kazakhstan-cross-border.pay-once')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.pay-once-strong', {amount: amountText.value})), 1)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.key,
                  class: "kzt-row"
                }, [
                  _createElementVNode("span", _hoisted_16, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                      _createElementVNode("path", {
                        d: icons[row.icon]
                      }, null, 8, _hoisted_18)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(row.label), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(row.value), 1)
                  ]),
                  (row.copy)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "kzt-copy",
                        "aria-label": _ctx.$t('kazakhstan-cross-border.copy'),
                        onClick: _withModifiers(($event: any) => (_unref(copy)(null, row.copy)), ["prevent"])
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_23, [
                          _createElementVNode("path", {
                            d: icons.copy
                          }, null, 8, _hoisted_24)
                        ]))
                      ], 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "kzt-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, [
                  (receiverLogo.value && !logoFailed.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "kzt-logo",
                        src: receiverLogo.value,
                        alt: "",
                        onError: _cache[1] || (_cache[1] = ($event: any) => (logoFailed.value = true))
                      }, null, 40, _hoisted_27))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_28, [
                        _createElementVNode("path", {
                          d: icons.bank
                        }, null, 8, _hoisted_29)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('kazakhstan-cross-border.field-receiver-bank')), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(receiverBank.value), 1)
                ]),
                (countryName.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      (showTajikFlag.value)
                        ? (_openBlock(), _createElementBlock("svg", {
                            key: 0,
                            class: "kzt-flag",
                            viewBox: "0 0 28 16",
                            role: "img",
                            "aria-label": countryName.value
                          }, _cache[7] || (_cache[7] = [
                            _createStaticVNode("<path fill=\"#cc2028\" d=\"M0 0h28v5H0z\"></path><path fill=\"#fff\" d=\"M0 5h28v6H0z\"></path><path fill=\"#168447\" d=\"M0 11h28v5H0z\"></path><path fill=\"none\" stroke=\"#d9ad20\" stroke-width=\".8\" d=\"M11 8l1 2h4l1-2-2 1-1-2-1 2z M12 11h4\"></path><g fill=\"#d9ad20\"><circle cx=\"10\" cy=\"7\" r=\".45\"></circle><circle cx=\"12\" cy=\"6.2\" r=\".45\"></circle><circle cx=\"14\" cy=\"5.8\" r=\".45\"></circle><circle cx=\"16\" cy=\"6.2\" r=\".45\"></circle><circle cx=\"18\" cy=\"7\" r=\".45\"></circle></g>", 5)
                          ]), 8, _hoisted_34))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(countryName.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "kzt-btn kzt-btn--secondary",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (modal.value = 'instruction'), ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                  _createElementVNode("path", {
                    d: icons.graduation
                  }, null, 8, _hoisted_36)
                ])),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('kazakhstan-cross-border.instruction')), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.time-left')), 1),
                _createElementVNode("span", null, _toDisplayString(timeLeft.value), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", {
                  class: _normalizeClass(progressClass.value),
                  style: _normalizeStyle({width: timePercent.value + '%'})
                }, null, 6)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "kzt-btn kzt-btn--success",
                disabled: !canAct.value,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (modal.value = 'confirm'), ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_41, [
                  _createElementVNode("path", {
                    d: icons.doubleCheck
                  }, null, 8, _hoisted_42)
                ])),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('kazakhstan-cross-border.paid')), 1)
              ], 8, _hoisted_40)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "kzt-cancel",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.cancelDeal(null)), ["prevent"]))
            }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.cancel')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("section", _hoisted_43, [
            (phase.value === 'verify')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "kzt-state__icon" }, [
                    _createElementVNode("span", { class: "kzt-spinner" })
                  ], -1)),
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t(isDispute.value ? 'kazakhstan-cross-border.dispute-title' : 'kazakhstan-cross-border.verify-title')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(isDispute.value ? 'kazakhstan-cross-border.dispute-text' : 'kazakhstan-cross-border.verify-text')), 1)
                ], 64))
              : (isPaid.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_45, [
                        _createElementVNode("path", {
                          d: icons.check
                        }, null, 8, _hoisted_46)
                      ]))
                    ]),
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.success-title')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.success-text')), 1)
                  ], 64))
                : (isExpired.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_48, [
                          _cache[10] || (_cache[10] = _createElementVNode("circle", {
                            cx: "12",
                            cy: "13",
                            r: "9"
                          }, null, -1)),
                          _createElementVNode("path", {
                            d: icons.clock
                          }, null, 8, _hoisted_49)
                        ]))
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.expired-title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.expired-text')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_50, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_51, [
                          _createElementVNode("path", {
                            d: icons.close
                          }, null, 8, _hoisted_52)
                        ]))
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.cancelled-title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.cancelled-text')), 1)
                    ], 64)),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("span", _hoisted_54, [
                (_openBlock(), _createElementBlock("svg", _hoisted_55, [
                  _cache[11] || (_cache[11] = _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  _createElementVNode("path", {
                    d: icons.info
                  }, null, 8, _hoisted_56)
                ]))
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('kazakhstan-cross-border.payment-number')), 1),
                _createElementVNode("span", _hoisted_59, _toDisplayString(invoiceNumber.value), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "kzt-copy",
                "aria-label": _ctx.$t('kazakhstan-cross-border.copy'),
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(copy)(null, invoiceNumber.value)), ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_61, [
                  _createElementVNode("path", {
                    d: icons.copy
                  }, null, 8, _hoisted_62)
                ]))
              ], 8, _hoisted_60)
            ]),
            (phase.value === 'result' && returnUrl.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 4,
                  href: returnUrl.value,
                  class: "kzt-btn"
                }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.return')), 9, _hoisted_63))
              : _createCommentVNode("", true)
          ]))
    ]),
    (modal.value !== null && phase.value === 'pay')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "kzt-overlay",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["kzt-modal", {'kzt-modal--instruction': modal.value === 'instruction'}]),
            role: "dialog",
            "aria-modal": "true"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "kzt-modal__close",
              "aria-label": _ctx.$t('kazakhstan-cross-border.close'),
              onClick: _withModifiers(closeModal, ["prevent"])
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_65, [
                _createElementVNode("path", {
                  d: icons.close
                }, null, 8, _hoisted_66)
              ]))
            ], 8, _hoisted_64),
            _createElementVNode("h2", _hoisted_67, _toDisplayString(modalTitle.value), 1),
            (modal.value === 'instruction')
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.$t('kazakhstan-cross-border.instruction-text')), 1),
                  _createElementVNode("div", _hoisted_70, [
                    (instructionFailed.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(_ctx.$t('kazakhstan-cross-border.instruction-failed')), 1))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: INSTRUCTION_GIF,
                          alt: _ctx.$t('kazakhstan-cross-border.instruction-alt'),
                          onError: _cache[6] || (_cache[6] = ($event: any) => (instructionFailed.value = true))
                        }, null, 40, _hoisted_72))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "kzt-btn",
                    onClick: _withModifiers(closeModal, ["prevent"])
                  }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.close')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_75, [
                      _createElementVNode("path", {
                        d: icons.warning
                      }, null, 8, _hoisted_76)
                    ])),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('kazakhstan-cross-border.confirm-warning')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.$t('kazakhstan-cross-border.confirm-text')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmRows.value, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.key,
                      class: "kzt-row"
                    }, [
                      _createElementVNode("span", _hoisted_78, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_79, [
                          _createElementVNode("path", {
                            d: icons[row.icon]
                          }, null, 8, _hoisted_80)
                        ]))
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("span", _hoisted_82, _toDisplayString(row.label), 1),
                        _createElementVNode("span", _hoisted_83, _toDisplayString(row.value), 1)
                      ]),
                      (row.copy)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "kzt-copy",
                            "aria-label": _ctx.$t('kazakhstan-cross-border.copy'),
                            onClick: _withModifiers(($event: any) => (_unref(copy)(null, row.copy)), ["prevent"])
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_85, [
                              _createElementVNode("path", {
                                d: icons.copy
                              }, null, 8, _hoisted_86)
                            ]))
                          ], 8, _hoisted_84))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.invoice.isTrxIdRequiredForConfirm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('invoice.transaction-id-label')), 1),
                        _createElementVNode("input", {
                          id: "kzt-trx-input",
                          class: _normalizeClass(["kzt-input", {'is-error': _ctx.transactionIdError}]),
                          type: "text",
                          value: _ctx.transactionId,
                          placeholder: _ctx.$t('invoice.transaction-id-placeholder'),
                          onInput: onTransactionIdInput
                        }, null, 42, _hoisted_89),
                        (_ctx.transactionIdError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.transactionIdError), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "kzt-btn kzt-btn--success",
                    disabled: !canAct.value || confirmPending.value,
                    onClick: _withModifiers(onConfirm, ["prevent"])
                  }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.confirm')), 9, _hoisted_91),
                  _createElementVNode("button", {
                    type: "button",
                    class: "kzt-btn kzt-btn--secondary",
                    onClick: _withModifiers(closeModal, ["prevent"])
                  }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.back-to-payment')), 1)
                ]))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["kzt-toast", {'is-visible': !!_unref(copyState).copyHintTimeout}])
    }, _toDisplayString(_ctx.$t('kazakhstan-cross-border.copied')), 3)
  ]))
}
}

})